<template>
  <el-dialog :title="title" :visible="true" width="95%" :before-close="close">
    <!--    <el-table :data="row.imgList">-->
    <!--      <el-table-column label="序号" type="index"></el-table-column>-->
    <!--      <el-table-column label="发票编号" prop="invoiceNo"></el-table-column>-->
    <!--      <el-table-column label="发票照片">-->
    <!--        <template slot-scope="scope">-->
    <!--          <el-image-->
    <!--            style="width: 150px;height: 150px;"-->
    <!--            :src="scope.row.invoicePic"-->
    <!--            :preview-src-list="row.imgList.map(i => i.invoicePic)"-->
    <!--          ></el-image>-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--    </el-table>-->
    <div style="overflow:hidden;display: flex;flex-wrap: wrap" ref="imageWrap">
      <el-card
        v-for="item in row.imgList"
        :key="item.invoiceNo"
        style="margin:8px"
      >
        <p>发票编号：{{ item.invoiceNo }}</p>
        <el-image
          ref="image"
          style="width: 150px;height: 150px;"
          :src="item.invoicePic"
          :preview-src-list="row.imgList.map(i => i.invoicePic)"
        ></el-image>
      </el-card>
      <!--      <div-->
      <!--        v-for="item in row.imgList"-->
      <!--        style="border: 1px solid #000;padding:20px;float: left"-->
      <!--      >-->
      <!--        <p>发票编号：{{ item.invoiceNo }}</p>-->
      <!--        <el-image-->
      <!--          style="width: 150px;height: 150px;"-->
      <!--          :src="item.invoicePic"-->
      <!--          :preview-src-list="row.imgList.map(i => i.invoicePic)"-->
      <!--        ></el-image>-->
      <!--      </div>-->
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'invoice-detail-park-look',
  // components: { BaseTable, BasePagination },
  // mixins: [baseTableMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      imageIndex: 0,
      currentPreview: null
    };
  },
  methods: {
    close() {
      this.remove();
    }
  },
  mounted() {
    const _this = this;
    setTimeout(() => {
      const images = _this.$refs['image']; //showViewer
      for (let i = 0; i < images.length; i++) {
        let cur = images[i];
        _this.$watch(
          () => {
            return images[i].showViewer;
          },
          function(v) {
            this.imageIndex = cur.imageIndex;
          }
        );
      }
    });
    this.$nextTick(() => {
      // images.map((img, i) => {
      //   console.log('img' + i);
      //   console.log(img);
      //   _this.$watch(images[i].showViewer, function(v) {
      //     console.log(v);
      //   });
      // });
    });
  }
};
</script>
<style lang="scss" scoped>
.picBox {
  padding: 0 30px 30px;
  border-radius: 12px;

  img {
    border: 1px solid #979797;
    width: 973px;
  }

  .btnBox {
    margin: auto;
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    width: 60%;
  }
}

.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  font-weight: bold;
}

.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}

.shadowBox {
  width: 1060px;
  padding: 15px 0;
  background: #f5f7fa;
  margin-bottom: 80px;
  margin-left: 50px;
}

.box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 20px;

  > div {
    display: flex;
    align-items: center;
    margin-right: 130px;
    margin-bottom: 20px;
  }

  label {
    color: #333333;
    font-size: 14px;
    width: 150px;
  }

  img {
    width: 174px;
    height: 112px;
  }

  .picInput {
    width: 174px;
    box-sizing: border-box;
  }

  li {
    margin-right: 48px;
  }
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #efefef;
  width: 100%;
  margin-bottom: 40px;

  .left {
    color: #9b9b9b;
    font-size: 20px;
  }

  .right {
    font-size: 14px;
    color: #9b9b9b;
  }
}

.radioGroup {
  display: flex;
  margin-top: 20px;
  justify-content: flex-start;
}
</style>
